import * as moment from 'moment';
import { Reducer } from 'redux';
import { AuthAction, AuthActionType } from '../actions';
import { Auth } from '../store';
import localStore from '../utils/LocalStore';

type ReducerState = Auth | null;
type ReducerAction = AuthAction;

const initialState: ReducerState = localStore.auth();

export const auth: Reducer<ReducerState> = (state: ReducerState = initialState, action: ReducerAction): ReducerState => {
    switch (action.type) {
        case AuthActionType.UserAuthenticated:
            return {
                token: action.token.token,
                date: moment.now()
            };
        case AuthActionType.UserLoggedOut:
            return null;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.ts